import { Lang } from '../../../translations/lang'

export const TableHeaderContractAndManagementNo = () => (
  <div>
    <div>{Lang.contractNo}</div>
    <div>{Lang.managementNo}</div>
  </div>
)
